import { render, staticRenderFns } from "./metrics_student_class_ranking.vue?vue&type=template&id=2605195e&scoped=true&"
import script from "./metrics_student_class_ranking.vue?vue&type=script&lang=js&"
export * from "./metrics_student_class_ranking.vue?vue&type=script&lang=js&"
import style0 from "./metrics_student_class_ranking.vue?vue&type=style&index=0&id=2605195e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605195e",
  null
  
)

export default component.exports